/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OneOfPropertyOfPtw100InternalArea } from './OneOfPropertyOfPtw100InternalArea';
import {
    instanceOfOneOfPropertyOfPtw100InternalArea,
    OneOfPropertyOfPtw100InternalAreaFromJSON,
    OneOfPropertyOfPtw100InternalAreaFromJSONTyped,
    OneOfPropertyOfPtw100InternalAreaToJSON,
} from './OneOfPropertyOfPtw100InternalArea';

/**
 * @type CreateOtherMvTherapyMachineDtoPtw100AreaName
 * 
 * @export
 */
export type CreateOtherMvTherapyMachineDtoPtw100AreaName = OneOfPropertyOfPtw100InternalArea;


export function CreateOtherMvTherapyMachineDtoPtw100AreaNameFromJSON(json: any): CreateOtherMvTherapyMachineDtoPtw100AreaName {
    return CreateOtherMvTherapyMachineDtoPtw100AreaNameFromJSONTyped(json, false);
}

export function CreateOtherMvTherapyMachineDtoPtw100AreaNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOtherMvTherapyMachineDtoPtw100AreaName {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...OneOfPropertyOfPtw100InternalAreaFromJSONTyped(json, true) };
    return  OneOfPropertyOfPtw100InternalAreaFromJSONTyped(json, true);
}

export function CreateOtherMvTherapyMachineDtoPtw100AreaNameToJSON(value?: CreateOtherMvTherapyMachineDtoPtw100AreaName | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfOneOfPropertyOfPtw100InternalArea(value)) {
        return OneOfPropertyOfPtw100InternalAreaToJSON(value as OneOfPropertyOfPtw100InternalArea);
    }

    return {};
}

/**
 * Check if a given object implements the CreateOtherMvTherapyMachineDtoPtw100AreaName interface.
 */
export function instanceOfCreateOtherMvTherapyMachineDtoPtw100AreaName(value: any): value is CreateOtherMvTherapyMachineDtoPtw100AreaName {
    if (instanceOfOneOfPropertyOfPtw100InternalArea(value)) return true;
    return false;
}

